import { STATUS_TYPE } from '../../../enum';

export interface FindUserWishlist {
  userId: string;
  limit?: number;
  skip?: number;
  entityType?: 'category_cake' | 'bundle_product';
}

export interface WishlistItemDetails {
  id?: string;
  labelEn?: string;
  labelAr?: string;
  price?: number;
  discountedPrice?: number;
  previewUrl?: string | null;
  activeState?: boolean;
  category?: {
    labelEn?: string;
    labelAr?: string;
    emoji?: string | null;
  } | null;
  subcategory?: {
    labelEn?: string;
    labelAr?: string;
  } | null;
}

export interface UserWishlistRow {
  id: string;
  userId: string;
  entityType: 'category_cake' | 'bundle_product';
  entityId: string;
  createdAt: string;
  updatedAt?: string;
  available?: boolean;
  item?: WishlistItemDetails | null;
}

export interface InitialState {
  data: UserWishlistRow[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
